import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ot-root" }
const _hoisted_2 = { class: "ot-topnav" }
const _hoisted_3 = { class: "ot-topnav-actions" }
const _hoisted_4 = { class: "stage" }
const _hoisted_5 = {
  class: "wordmark",
  "aria-label": "ObraTycoon"
}
const _hoisted_6 = { class: "obra" }
const _hoisted_7 = { class: "tycoon" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ot-topnav-brand" }, "ObraTycoon", -1)),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("button", {
          class: "tn-btn",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goEntrar && _ctx.goEntrar(...args)))
        }, "Login"),
        _createElementVNode("button", {
          class: "tn-btn tn-btn--primary",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRegistro && _ctx.goRegistro(...args)))
        }, "Registro")
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList('Obra', (ch, i) => {
            return _createElementVNode("span", {
              key: 'o' + i,
              class: "ch",
              style: _normalizeStyle({ animationDelay: (0.25 + i * 0.045).toFixed(3) + 's' })
            }, _toDisplayString(ch), 5)
          }), 64))
        ]),
        _createElementVNode("span", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList('Tycoon', (ch, i) => {
            return _createElementVNode("span", {
              key: 't' + i,
              class: "ch",
              style: _normalizeStyle({ animationDelay: (0.25 + (4 + i) * 0.045).toFixed(3) + 's' })
            }, _toDisplayString(ch), 5)
          }), 64))
        ])
      ]),
      _createElementVNode("nav", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn is-primary",
          type: "button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goPlanos && _ctx.goPlanos(...args)))
        }, "Planos"),
        _createElementVNode("button", {
          class: "btn is-quiet",
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goSaiba && _ctx.goSaiba(...args)))
        }, "Saiba mais")
      ])
    ]),
    _createElementVNode("footer", _hoisted_9, [
      _createVNode(_component_router_link, {
        class: "footer-legal-link",
        to: "/termos"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("Termo de Uso", -1)
        ]))]),
        _: 1
      }),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "footer-dot" }, "·", -1)),
      _createVNode(_component_router_link, {
        class: "footer-legal-link",
        to: "/privacidade"
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("Política de Privacidade", -1)
        ]))]),
        _: 1
      }),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "footer-dot" }, "·", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("a", {
        class: "footer-gus",
        href: "https://www.gusmachado.com.br/",
        target: "_blank",
        rel: "noopener"
      }, "by GusMachado", -1))
    ])
  ]))
}